<template>
  <ZigzagServiceLayout
    mainTitle="Terapia de Reemplazo Hormonal (TRH)"
    mainDescription="Atención personalizada para el equilibrio y la vitalidad. Brindamos terapias hormonales seguras y médicamente supervisadas para restaurar el equilibrio."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'HormoneReplacementContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'SALUD FEMENINA',
          title: 'Restaurando el Equilibrio y Comodidad',
          subtitle: 'Planes de tratamiento personalizados para mujeres.',
          paragraphs: [
            "Los desequilibrios hormonales pueden afectar profundamente la calidad de vida de una mujer. Ofrecemos adaptaciones precisas para cada paciente.",
            "Ya sea que necesite terapia con estrógeno y progesterona, hormonas bioidénticas o apoyo tiroideo, estamos aquí para apoyar su bienestar."
          ],
          list: [
            "Terapia con estrógeno y progesterona",
            "Recetas de hormonas bioidénticas",
            "Optimización tiroidea",
            "Terapias de péptidos para la vitalidad"
          ],
          image: '/images/services/hrt-women.png'
        },
        {
          label: 'SALUD MASCULINA',
          title: 'Vitalidad y Testosterona',
          subtitle: 'Combate la fatiga y restaura tu fuerza.',
          paragraphs: [
            "A medida que los hombres envejecen, la disminución de testosterona puede causar una pérdida de energía y fuerza. Nuestros programas TRT revierten este proceso.",
            "Nuestros planes hormonales masculinos se enfocan en restaurar la vitalidad y aumentar el apoyo suprarrenal para manejar el estrés."
          ],
          list: [
            "Terapia de reemplazo de testosterona (TRT)",
            "Planes de optimización tiroidea",
            "Tratamientos directos y seguros",
            "Apoyo suprarrenal y de cortisol"
          ],
          image: '/images/services/hrt-men.png'
        },
        {
          label: 'SEGURIDAD Y PROTOCOLOS',
          title: 'Monitoreo y Opciones',
          subtitle: 'Cada tratamiento bajo estricta supervisión médica.',
          paragraphs: [
            "La terapia hormonal se adapta exclusivamente a su cuerpo. Cada paso es evaluado por un experto.",
            "Ofrecemos varias opciones, como inyecciones semanales, gránulos (pellets), y cremas. Todo para su conveniencia."
          ],
          list: [
            "Pruebas de laboratorio completas",
            "Monitoreo continuo y ajustes",
            "Modalidades flexibles: Pellets, Cremas, Inyecciones",
            "Seguimientos por telemedicina"
          ],
          image: '/images/services/hrt-safety.png'
        }
      ]
    };
  }
};
</script>
